import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { SecurityService, CustomQueryEncoderHelper } from '../../Core/Security/security.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { LogService } from '../../Core/Abstract/log.service';

import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';

@Injectable()

export class ForgotPasswordService extends SecurityService {

    constructor(http: HttpClient, configService: ConfigService, eventsEmitterService: EventsEmitterService, router: Router, logger: LogService) {
        super(http, configService, eventsEmitterService, router, logger);
    }

    public forgotPasswordRequest(forgotPassword){

        let serviceUrl = this.baseUrl + 'RegistrationService/resetPassword';
        let headers = new HttpHeaders({
            'Content-Type': 'application/json; charset=utf-8'
        });
        let options = ({ headers: headers });

        return this.http.post(serviceUrl, forgotPassword, options).pipe(map(super.extractData),catchError(super.handleError));
    }

}